<template>
  <div id="contenedor-configuracion-main" class="bkground fill-height">
    <v-container fluid class="pa-6">
      <router-view />
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracionMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#contenedor-configuracion-main {
  min-height: 100vh;
}
</style>
